import type { Contest } from "@/types/api/contest"
import { DEFAULT_TZ } from "@/utils/date"
import { MFM_EVENT_ALIAS } from "@/utils/mfm"

export const applicationsStates = {
  _NOT_FILLED: {
    text: "applicationNotFilled",
    color: "disabled",
  },
  SENT: {
    text: "applicationSent",
    color: "purple",
  },
  UNDER_REVIEW: {
    text: "applicationUnderReview",
    color: "warning",
  },
  REVIEWED: {
    text: "rated",
    color: "success",
  },
} as const

export function getContestDatesParams (
  contest?: Contest | null,
  locale?: string,
): [string, Record<string, string>] {
  const formatter = new Intl.DateTimeFormat(locale, {
    dateStyle: "short",
    timeZone: DEFAULT_TZ,
  })

  const start = contest?.start
    ? formatter.format(contest.start)
    : ""

  const finish = contest?.finish
    ? formatter.format(contest.finish)
    : ""

  if (start && !finish)
    return ["fromDate", { minBirthdate: start }]

  if (!start && finish)
    return ["beforeDate", { maxBirthdate: finish }]

  if (start && finish)
    return ["betweenDates", { minBirthdate: start, maxBirthdate: finish }]

  return ["", {}]
}

export const VALID_CONTEST_STATUSES = [
  "participant",
  "volunteer",
]

export function getValidContestStatuses (eventAlias?: string): string[] {
  return eventAlias === MFM_EVENT_ALIAS
    ? ["participant"]
    : VALID_CONTEST_STATUSES
}
